/**
 * Created by Jasmine on 2018/6/6.
 */
import React from 'react';
import history from './history';

import notification from 'antd/lib/notification';
import Button from 'antd/lib/button';

export default class Utils extends React.Component {
    /**
     * 打开系统通知信息框
     * @param key
     * @param url
     * @param title
     * @param msg
     * @param callback 回调函数
     */
    static notice(key, url, title, msg, callback) {
        let btn = url === null ?
            <Button type="primary" onClick={() => {
                notification.close(key);
            }}
            >我知道了</Button>
            :
            <Button type="primary" onClick={() => {
                history.push(url);
                notification.close(key);
                callback();
            }}
            >前往设置</Button>;

        notification.open({
            key: key,
            message: title,
            description: msg,
            duration: null,
            btn
        });
    }

}
